import { Component, Input, OnInit } from '@angular/core';
import { IconType } from '../icon/icon.component';

@Component({
  selector: 'hum-secondary-button',
  templateUrl: './secondary-button.component.html',
  styleUrls: ['./secondary-button.component.scss']
})
export class SecondaryButtonComponent implements OnInit {
  @Input() icon: IconType
  constructor() { }

  ngOnInit(): void {
  }

}
